import { Component, inject, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslatePipe } from '@ngx-translate/core';
import {
	InfoGroupComponent,
	ItemComponent,
	TagComponent,
	TileComponent,
	CollapseComponent,
} from '@tecalisdev/infinity';
import { IHomeOperation, OPERATION_TYPE } from '../../../../../operations/models/operations.models';
import { WorkflowsHelperService } from '../../../../services/workflows-helper.service';
import { TextLocalePreviewComponent } from '../../../../../shared/components/text-locale-preview/text-locale-preview.component';
import { DeveloperCurlButtonComponent } from '../../../../../shared/components/developer-curl-button/developer-curl-button.component';

@Component({
	selector: 'app-home-operation',
	imports: [
		TranslatePipe,
		TileComponent,
		ItemComponent,
		TagComponent,
		InfoGroupComponent,
		CollapseComponent,
		TextLocalePreviewComponent,
		DeveloperCurlButtonComponent,
	],
	templateUrl: './home-operation.component.html',
	styleUrl: './home-operation.component.scss',
})
export class HomeOperationComponent implements OnInit {
	@Input() operation?: IHomeOperation;
	@Input() index: number = 1;
	@Input() profileUuid?: string;

	public workflowsHelper = inject(WorkflowsHelperService);
	private sanitizer = inject(DomSanitizer);

	private sanitizedPolicies: Map<number, SafeHtml> = new Map();
	public safeTecalisPolicy: SafeHtml = '';

	ngOnInit(): void {
		if (this.operation && this.operation.type !== OPERATION_TYPE.HOME) {
			this.operation = undefined;
			return;
		}

		this.sanitizePolicies();
	}

	public operationCurlPath(): string {
		if (!this.profileUuid || !this.operation?.uuid) return '';
		return `/profile/${this.profileUuid}/operations/${this.operation.uuid}`;
	}

	private sanitizePolicies(): void {
		this.safeTecalisPolicy = this.sanitizer.bypassSecurityTrustHtml(this.workflowsHelper.tecalisPolicy);

		this.operation?.config?.policy_checks?.forEach((policy, index) => {
			const sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(policy.html);
			this.sanitizedPolicies.set(index, sanitizedHtml);
		});
	}

	public getSanitizedPolicy(index: number): SafeHtml {
		return this.sanitizedPolicies.get(index) || '';
	}
}
